<body class="ltr main-body leftmenu">

	<!-- Main Content-->
	<div class="main-content side-content pt-0 ml-0">
		<div class="main-container container-fluid">
			<div class="inner-body">
				<div class="row row-sm" *ngIf="list">
					<div class="col-lg-12">
						<div class="card custom-card">
							<div class="card-body">
								<div class="row">
									<div class="col-md-8">
                                        <div class=" d-flex align-items-center pl-3">
                                            <img alt="Logo" src="../../assets/img/clock.png" class="mh-45px pb-2">
                                            <div class="ml-2">
                                              <h3 class="main-content-label mb-1"><b>
											Session
                                              </b></h3>
                                              <p class="text-muted card-sub-title mb-0">
												List Of Sessions
                                              </p>
                                            </div>
                                          </div> 
                                    </div>
									<div class="col-md-3" [formGroup]="SessionSearchForm">
										<mat-form-field appearance="outline" class="example-full-width" >
											<mat-label>{{'header.session-data.titleList.Search'| translate}}</mat-label>
											<input class="color" matInput placeholder="Search" (keyup)="keypress()"
												formControlName="SearchString">
											<mat-icon matSuffix>search</mat-icon>
										</mat-form-field>
									</div>
									<div class="col-md-1 prpl" *ngIf="(submitButton || editButton)">
										<button id="addBtn" type="button"
											class="btn btn-primary btn-icon-text  mt-1 mb-3"
											(click)="addnewrecord()">
											<span style="display: flex; align-items: center;">
												<img width="20vh" src="../../assets/img/plus.gif"
													style="margin-right: 5px;"> 
												   New
											</span>
										</button>
									</div>
								</div>
								
								<hr class="mt-0">
								<div class="table-responsive table-container">
									<table appShortTable id="datatable" class="table table-bordered text-nowrap">
										<thead>
											<tr>
												<th width="10%" class="f600">
													Session No.
												</th>
												<th width="6%"  class="f600">
													{{'header.session-data.table.SessionYear'| translate}}
												</th>
												<th width="6%"  class="f600">
													{{'header.session-data.table.SessionCode'| translate}}
												</th>
												<th width="50%"  class="f600">
													{{'header.session-data.table.SessionName'| translate}}
												</th>
												<th width="4%"  class="f600">
													{{'header.session-data.table.SessionDefault'| translate}}
												</th>
												<th width="4%"  class="f600">
													{{'header.session-data.table.SessionStatus'| translate}}
												</th>
												<th width="10%"  *ngIf="submitButton" class="f600 text-center">{{'header.session-data.table.Action'|
													translate}}</th>
												<th  width="10%" *ngIf="!submitButton" class="f600 text-center">Switch Session</th>
											</tr>
										</thead>
										<tbody id="table_data">
											<tr *ngFor="let session of sessionList;">

												<td>{{session.SnNo}}</td>
												<td>{{session.SnYear}}</td>
												<td>{{session.SnCode}}</td>
												<td>{{session.SnName}}</td>
												<td>{{session.SnDefault}}</td>
												<td>{{session.SnStatus}}</td>
												<td *ngIf="submitButton" class="text-center">
													<a class="floating" title="Edit" (click)="editData(session)">
														<i class="fa fa-edit"></i>
													</a>
												</td>
												<td *ngIf="!submitButton" class="text-center">
													<a class="floating" title="Switch User" (click)="switchSession(session)">
														<i class="fa fa-refresh"></i>
													</a>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
								<mat-paginator class="align" [length]="totalItems" [pageSize]="pageSize"
                                        [pageSizeOptions]="pageSizeOptions"
                                        (page)="onPageChange($event)"></mat-paginator>
							</div>
						</div>
					</div>
				</div>
				
			</div>
		</div>
	</div>
</body>